import { render, staticRenderFns } from "./JobModal.vue?vue&type=template&id=70e71d79&scoped=true"
import script from "./JobModal.vue?vue&type=script&lang=js"
export * from "./JobModal.vue?vue&type=script&lang=js"
import style0 from "./JobModal.vue?vue&type=style&index=0&id=70e71d79&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e71d79",
  null
  
)

export default component.exports